import { isNil } from 'lodash';
import { decryptKey, PrivateKey, readKey, readPrivateKey } from 'openpgp';

import { ParseKeyPairInput, ParseKeyPairOutput } from './interfaces';

export const parseKeyPair = async (params: ParseKeyPairInput): Promise<ParseKeyPairOutput> => {
  const publicKey = await readKey({ ...getBinaryOrArmoredKey(params.publicKey) } as any);
  let privateKey: PrivateKey | undefined;
  if (!isNil(params.privateKey)) {
    privateKey = await readPrivateKey({ ...getBinaryOrArmoredKey(params.privateKey.privateKey) } as any);
    if (!isNil(params.privateKey.passphrase)) {
      privateKey = await decryptKey({
        privateKey,
        passphrase: params.privateKey.passphrase,
      });
    }
  }
  return { publicKey, privateKey };
};

const getBinaryOrArmoredKey = (value: string | Uint8Array): { armoredKey: string } | { binaryKey: Uint8Array } => {
  if (isNil(value)) {
    console.error('getBinaryOrArmoredKey: Cannot parse because required value is nil', { value });
    throw new Error('getBinaryOrArmoredKey: Cannot parse because required value is nil');
  }
  if (value instanceof Uint8Array) {
    return { binaryKey: value };
  }
  if (typeof value === 'string') {
    return { armoredKey: value };
  }
  console.error('getBinaryOrArmoredKey: Unknown value', { value });
  throw new Error('getBinaryOrArmoredKey: Unknown type');
};
